var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"height":_vm.h,"width":_vm.w}},[_c('polygon',{class:`icon ${_vm.active ? 'active' : ''}`,attrs:{"points":_vm.getPoints()}}),_vm._v(" Sorry, your browser does not support inline SVG. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }